import React from 'react';
import LogoIcon from '../../svg/LogoIcon';
import Button from '../Button';
import Burger from '../Burger/Burger';
import MenuStyled from '../Menu/MenuStyled';

const Header = () => (
  <header className=" sticky bg-blue z-50 md:static top-0 ">
    <div className="container flex flex-row sm:flex-row justify-between md:items-center md:mx-auto py-4 md:px-8">
      <div className="w-56 md:flex md:w-64 ">
        <LogoIcon />
      </div>

      <div className="mt-2 md:mt-0 flex">
        <Burger />
      </div>
    </div>
  </header>
);

export default Header;

/*<Button 
className="bg-yellow text-sm hover:bg-red transition ease-in duration-500"
>
  Menu Placeholder
  </Button>*/
